module.exports=function(scope){ return `<div id="${scope.id}" class="asseco-floaty">
    <div class="asseco-floaty-btn">
        ${scope.icon}
    </div>
</div>`};